export interface InternationalizationState {
  visitorIsFromIndia: boolean;
}

export const defaultInternationalizationState: InternationalizationState = {
    visitorIsFromIndia: false
};